import * as React from 'react';
import { cn } from '@/lib/utils';

interface StyledCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  contentClassName?: string;
}

const StyledCard = React.forwardRef<HTMLDivElement, StyledCardProps>(
  ({ className, title, children, contentClassName, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'relative w-full',
        'flex flex-col justify-stretch items-stretch',
        // Pseudo-element for rounded border
        "before:content-[''] before:absolute before:inset-0 before:rounded-xl before:border before:border-border before:pointer-events-none before:z-1 before:bg-zinc-100",
        className
      )}
      {...props}
    >
      {/* Title header that looks like table header */}
      <div
        className={cn(
          'relative z-0 px-6 py-3 text-left text-xs font-medium text-muted-foreground',
          'border-b border-zinc-100'
        )}
      >
        {title}
      </div>

      {/* Content area */}
      <div
        className={cn(
          'relative z-0 px-6 py-4',
          'grow',
          'rounded-xl',
          "before:content-[''] before:absolute before:inset-0 before:rounded-xl before:border before:border-border before:pointer-events-none before:z-0 ",
          // Background for content area
          'bg-background',
          // Rounded corners for content area
          'rounded-b-lg',
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  )
);
StyledCard.displayName = 'StyledCard';

export { StyledCard };
